import {
  FaProjectDiagram,
  FaShieldAlt,
  FaCodeBranch,
  FaCogs,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-ingress.png";

export const INGRESS_CONSTANTS = {
  HERO: {
    title: "OneMind Services — Ingress NGINX Controller (One-Click Application) ",
    desc: "Effortlessly manage your Kubernetes ingress traffic with OneMind’s fully managed Ingress NGINX Controller. We handle the infrastructure, so you can focus on deploying your applications seamlessly.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "Ingress NGINX is an open-source Ingress controller for Kubernetes that uses NGINX as a reverse proxy and load balancer. It manages external access to services within a Kubernetes cluster, providing features like SSL termination, path-based routing, and more.",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure Ingress NGINX instance in minutes—no need to install or manage dependencies. ",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach :  Deploy in any of our multiple data-center regions to keep latency low and performance high. ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes Ingress NGINX controller, default configurations, and optimized system settings. ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, Ingress NGINX operates within your Kubernetes cluster. ",
      },
    ],
    installation: {
      heading: "Installation Location -",
      text: "Ingress NGINX is deployed in the Kubernetes cluster under the namespace ",
      location: " ingress-nginx ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Kubernetes Ports, uses: ",
      list: ["80(HTTP)", "443(HTTPS)"],
    },
    note: "Note : Ingress NGINX integrates with the Kubernetes API server and does not expose a standalone configuration file. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaProjectDiagram,
        title: "Reverse Proxy & Load Balancing",
        text: "Efficiently routes external traffic to internal services based on defined rules.",
      },
      {
        icon: FaShieldAlt,
        title: "SSL/TLS Termination",
        text: "Handles SSL/TLS termination at the ingress, simplifying certificate management.",
      },
      {
        icon: FaCodeBranch,
        title: "Path-Based Routing",
        text: "Supports routing traffic to different services based on specific URL paths.",
      },
      {
        icon: FaCogs,
        title: "Custom Annotations",
        text: "Allows fine-tuning of ingress behavior through Kubernetes annotations.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or integrate standard backup procedures for Kubernetes resources. ",
      },
      {
        label: "Security Out of the Box",
        text: "Hardened with RBAC configurations and secure communication channels. ",
      },
      {
        label: "Scalable Architecture",
        text: "Scales with your Kubernetes cluster, supporting high-availability deployments. ",
      },
    ],
  },
  SUPPORT: {
    docsText: "Ingress NGINX Documentation",
    docsLink: "https://kubernetes.github.io/ingress-nginx/",
  },
};
